import React from 'react';
import ApiDocSpinner from '../ApiDocSpinner';
import { useTranslation } from 'react-i18next';

const ApiDocTable = ({ data, column, redirectTo, handleScroll, loading }) => {
	const { t } = useTranslation();

	return (
		<div className='w-full'>
			<div
				onScroll={handleScroll}
				className='w-full overflow-x-auto rounded-lg border border-gray-200'
			>
				<table className='w-full table-auto border-collapse'>
					<thead className='bg-gray-50'>
						<tr className='border-b border-gray-200'>
							{column.map((tableHead, index) => (
								<th
									key={index}
									className='px-4 py-3 text-left text-sm font-semibold text-gray-700'
								>
									{tableHead.HeadCell ? (
										tableHead.HeadCell({
											value: tableHead.heading,
											row: data[index],
										})
									) : (
										<div>{t(tableHead.heading)}</div>
									)}
								</th>
							))}
						</tr>
					</thead>

					<tbody className='bg-white'>
						{data?.length > 0 ? (
							data.map((row, rowIndex) => (
								<tr
									key={rowIndex}
									onClick={redirectTo ? () => redirectTo(row) : null}
									className={`border-b border-gray-100 hover:bg-gray-50 ${redirectTo ? 'cursor-pointer' : ''
										}`}
								>
									{column.map((tableData, colIndex) => (
										<td
											key={colIndex}
											className='px-4 py-3 text-sm text-gray-700 break-words'
										>
											{tableData.Cell ? (
												tableData.Cell({
													value: row[tableData.accessor],
													row,
												})
											) : tableData.accessor === 'parameter' ? (
												<>
													{row[tableData.accessor]}
													{row.optional ? ` (${t('optional')})` : ''}
												</>
											) : (
												t(row[tableData.accessor])
											)}
										</td>
									))}
								</tr>
							))
						) : loading ? (
							<tr>
								<td colSpan={column?.length} className='relative px-4 py-10 text-center'>
									<ApiDocSpinner style={{ position: 'absolute' }} />
								</td>
							</tr>
						) : (
							<tr>
								<td colSpan={column?.length} className='px-4 py-10 text-center'>
									<p className='text-sm text-gray-500'>{t('no_data_found')}</p>
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default ApiDocTable;
